export default __webpack_public_path__ + "static/27-ea0783526179c605f108b0cf68736d2d.jpg";